<div class="card">
    <div class="title">{{ formTitle }}</div>

    <form #form="ngForm" class="form">
        <div class="field">
            <input type="text" name="teamName" required [(ngModel)]="teamName" #teamNameModel="ngModel" placeholder=" " />
            <label>Team Name</label>
            <span class="error" *ngIf="teamNameModel.invalid && teamNameModel.touched">
                Team Name is required
            </span>
        </div>
    </form>

    <div class="table-container margin-top-medium">
        <table>
            <thead>
                <tr>
                    <th colspan="2">
                        Team Members
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let p of selectedPlayers">
                    <tr>
                        <td>{{ p.obj.firstName }} {{ p.obj.lastName }}</td>
                        <td>
                            <button type="button" (click)="removePlayerFromTeam(p)">Remove</button>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>

    <div class="table-container margin-top-medium">
        <table>
            <thead>
                <tr>
                    <th colspan="2">
                        Select Team Members
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let p of selectablePlayers">
                    <tr *ngIf="!p.isSelected">
                        <td>{{ p.obj.firstName }} {{ p.obj.lastName }}</td>
                        <td>
                            <button type="button" (click)="addPlayerToTeam(p)">
                            Add
                            </button>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>

    <button type="button" (click)="saveTeam()">{{ saveLabel }}</button>
</div>

<button type="button" (click)="cancel()" class="cancel">Cancel</button>
